var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "v-spinner-logo d-flex",
      style: { width: _vm.size, height: _vm.size }
    },
    [
      _c("inline-svg", {
        staticClass: "w-100 h-100",
        attrs: { src: "/media/images/logo-s.svg" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }